import React, {useEffect, useState} from "react";
import {AppName, GenRouteUrls, Keys, Modules, ReqUrls} from "../config/AppConfig";
import {Flexbox, Label, MsgBox} from "../../common/fusion-ui";
import {useTheme} from "../../common/ProjectThemeProvider";
import {focusFormIdElement, printError, printLog, sendRequest} from "../utils/AppUtils";
import {addClass, checkNullStr, createTimeout, getJsonValue, getElement, isBoolTrue, isJsonValueTrue, setTabTitle} from "../../common/fusion-ui/utils/ReactUtils";
import {CssVariant} from "../../common/fusion-ui/config/FusionConfig";
import {Link, useNavigate} from "react-router-dom";
import {AuthPageLayout, InvalidBypassTokenLabel, ThemedButton, ThemedInput} from "../index";
import {useSubdomainData} from "../context/SubdomainProvider";
import {BaseReqUrl} from "../../common/CommonConfig";
import {useInternetStatus} from "../../common/fusion-ui/hook";

const ForgotPwPage = React.memo(() => {
    const TAG = 'ForgotPwPage';

    const navigate = useNavigate();
    const theme = useTheme();
    const {subdomainData} = useSubdomainData();
    const {isOnline} = useInternetStatus();

    const FOCUS_DELAY = 2000;
    const INPUT_H = '46px';

    const Fields = {
        username: 'username',
        usernameMsg: 'usernameMsg',

        submitAsLoading: 'submitAsLoading',
        submitDisable: 'submitDisable',
        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',
    };
    const [fieldsData, setFieldsData] = useState({});

    useEffect(() => {
        setTabTitle(Modules.ForgotPw);
    }, []);

    return (<AuthPageLayout className={'py-sm-4'} px={0} py={1}>
        <div className={'m-0 row w-100 d-flex jc-center al-center px-4'}
             style={{minHeight: '90vh'}}
        >
            <div className={'m-0 risen-md rounded-4 px-5 py-3  col-sm-10 col-md-6 col-lg-5 transition-sm'}
                 style={{backgroundColor: theme.bg}}>
                {/*invalid-token-msg*/}
                <InvalidBypassTokenLabel mtn={'0 mt-2'}/>

                {/*top*/}
                <div className={'m-0 p-0'}>
                    <div className={'m-0 p-0 pb-1'}>
                        <Label className={'m-0 p-0 my-1 fw-bold fs-xl text-nowrap'} textAt={'start'} color={theme.primary}>
                            {getJsonValue(subdomainData, Keys.subdomain_Name, AppName)}
                        </Label>
                    </div>

                    <Label className={'m-0 p-0 fw-bold fs-xl text-nowrap'} textAt={'start'} color={theme.text}>
                        {`${Modules.ForgotPw}?`}
                    </Label>

                    <p className={'p-0 m-0 mb-3  text-wrap text-start'} color={theme.text80}>
                        {`Enter your username to retrieve your previous password`}
                    </p>
                </div>

                {/*form*/}
                <div className={'m-0 p-0 mt-1'}>
                    <form>
                        {/*username*/}
                        <ThemedInput
                            mainWrapperClassName={`w-100 pb-2`}
                            className={`py-3`}
                            style={{height: INPUT_H}}
                            type={'email'}
                            id={Fields.username}
                            label={'Username'}
                            placeholder={'Enter your username'}
                            value={getField(Fields.username)}
                            required={true}
                            msg={getField(Fields.usernameMsg)}
                            onChange={(e, isValid) => {
                                const value = e.target.value;
                                updateField(Fields.username, value);
                                if (checkNullStr(value)) {
                                    highlightIdField(Fields.username, false, Fields.usernameMsg, '');
                                }
                                panelLog('');
                            }}
                        />

                        {/*msg-box*/}
                        {(checkNullStr(getField(Fields.panelMsg)) || !isOnline) &&
                            <MsgBox color={!isOnline ? 'red' : getField(Fields.panelMsgColor, theme.text90)}>
                                {!isOnline ? `You're offline!` : getField(Fields.panelMsg)}
                            </MsgBox>}


                        {/*submit*/}
                        <div className={'m-0 p-0 mt-3 mb-1 w-100'}>
                            <ThemedButton
                                className={'w-100 px-2 py-2 rounded-3 fw-semi-bold'}
                                text={isFieldTrue(Fields.submitAsLoading) ? 'Submitting...' : 'Submit'}
                                height={INPUT_H}
                                elasticActive={true}
                                loadingWidth={'100%'}
                                asLoading={isFieldTrue(Fields.submitAsLoading)}
                                disabled={isFieldTrue(Fields.submitDisable) || !isOnline}
                                onClick={handleSubmit}
                            />
                        </div>

                        {/*forgot-pw & request-access*/}
                        <Flexbox className={'w-100 mt-3 px-0'} justifyAt={'between'}>
                            <span></span>

                            {/*request-access*/}
                            <div>
                                <span className={''}>
                                    <span className={'text-nowrap cursor-default'} style={{color: theme.text80}}>
                                        Back to&nbsp;
                                    </span>
                                    <Link to={GenRouteUrls.login}>
                                        <span className={'text-nowrap footer-link'}>
                                        {Modules.Login}
                                    </span>
                                    </Link>
                                </span>
                            </div>
                        </Flexbox>
                    </form>
                </div>
            </div>
        </div>
    </AuthPageLayout>);

    function handleSubmit() {
        const fun = 'handleSubmit:';
        log(fun, 'lastUrl:', getField(Fields.lastUrl));
        panelLog('');
        try {
            let verified = checkAllFieldsVerified();
            // verified = false;
            if (verified) {
                updateField(Fields.submitAsLoading, true);
                updateField(Fields.submitDisable, true);

                const REQUEST_OPTIONS = {
                    username: getField(Fields.username),
                    domainName: getJsonValue(subdomainData, Keys.subdomain_Name),
                    // loginLink: "https://speak.kolsandpeers.com/login",
                    loginLink: `${BaseReqUrl}${GenRouteUrls.login}`,
                };

                sendRequest({
                    reqUrl: ReqUrls.forgotPw,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: (fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        if (success) {
                            panelLog(message);

                            createTimeout(() => {
                                navigate(GenRouteUrls.login);
                            }, 10000);
                        } else {
                            panelLogErr(message);
                            updateField(Fields.submitDisable, false);
                        }
                        updateField(Fields.submitAsLoading, false);
                    },
                    onError: (error) => {
                        panelLogErr('Request failed, please try again');
                        updateField(Fields.submitAsLoading, false);
                        updateField(Fields.submitDisable, false);
                        logErr(fun, error);
                    }
                });
            }
        } catch (error) {
            panelLogErr('Request failed, please try again');
            updateField(Fields.submitAsLoading, false);
            updateField(Fields.submitDisable, false);
            logErr(fun, error);
        }
    }

    function checkAllFieldsVerified() {
        let verified = false;
        if (!checkNullStr(getField(Fields.username))) {
            updateField(Fields.usernameMsg, 'Username cannot be empty');
            focusIdField(Fields.username);
        } else {
            verified = true;
            panelLog("");
        }
        return verified;
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function focusIdField(id, onlyFocus = true) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
        highlightIdField(id, true);
    }

    function highlightIdField(id, highlight = true, msgField, msg, variant = CssVariant.danger) {
        if (checkNullStr(msgField)) updateField(msgField, msg);
        addClass(getElement(id, 'id'), variant, isBoolTrue(highlight));
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        log(...[text]);
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});

export default ForgotPwPage;
